import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader, Col, Row } from 'reactstrap';

import './ResultadoUpload.scss';

class ResultadoUpload extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			Total: 0,
			TotalEmitidos: 0,
			TotalPendentes: 0,
			TotalRejeitados: 0,
		};
	}

	toggleModal = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	openModal = params => {
		this.setState({
			isOpen: true,
			Total: params.Total,
			TotalEmitidos: params.TotalEmitidos,
			TotalPendentes: params.TotalPendentes,
			TotalRejeitados: params.TotalRejeitados,
		});
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

	handleModalClosed = () => {
		this.handleReset();
	};

	redirect = param => {
		window.location.href = param;
	};

	render() {
		return (
			<Modal
				id="modalResultadoUpload"
				toggle={this.closeModal}
				isOpen={this.state.isOpen}
				onClosed={this.handleModalClosed}
				backdrop="static">
				<ModalHeader>
					RESULTADO
					<div className="labelHeaderResultado">
						Foram importadas {this.state.Total} Notas Fiscais eletrônicas. Clique na opção que você deseja
						visualizar primeiro
					</div>
				</ModalHeader>
				<ModalBody>
					<Row>
						<Col>
							<Button color="info" block onClick={() => this.redirect('/pendentes')}>
								<span className="labelResultado">
									<i className="fas fa-share-square" />
									Pendentes: {this.state.TotalPendentes}
								</span>
							</Button>
						</Col>
						<Col>
							<Button color="info" block onClick={() => this.redirect('/emitidas')}>
								<span className="labelResultado">
									<i className="fas fa-print" />
									Emitidas: {this.state.TotalEmitidos}
								</span>
							</Button>
						</Col>
						<Col>
							<Button color="info" block onClick={() => this.redirect('/rejeitadas')}>
								<span className="labelResultado">
									<i className="fas fa-warning" />
									Rejeitadas: {this.state.TotalRejeitados}
								</span>
							</Button>
						</Col>
					</Row>
				</ModalBody>
			</Modal>
		);
	}
}

export default ResultadoUpload;
